import { useQueryClient } from "react-query";
import { useToast } from "../context/toast/ToastContext";
import { useNavigate } from "react-router";

const useSuccessHandler = () => {
  const toast = useToast();
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const showToast = (msg: string, shouldInvalidateQuery = true) => {
    toast.show(msg);
    if (shouldInvalidateQuery) {
      queryClient.invalidateQueries();
    }
  };

  const redirect = (path: string) => {
    navigate(path);
  };

  return {
    showToast,
    redirect,
  };
};

export default useSuccessHandler;
